// @flow
import React from 'react';
import { toNumber } from 'lodash';
import { FormattedText } from '@elements';
import { useTranslationNs } from '@helpers/helpers';
import ServiceService from '../../../services/ServiceService';
import './ServiceQuantityLine.scss';

type Props = {
  service: Object,
  servicesByQuantity: boolean,
};

// "55 U × R$ 12,90 · desconto R$ 59,50" (or "· acréscimo"); nothing for a flat-price sale or without the clinic flag.
// A span, because the tables' phone layout puts each cell in a <p>.
const ServiceQuantityLine = ({ service, servicesByQuantity }: Props) => {
  const [_] = useTranslationNs('financial');

  if (!servicesByQuantity || !ServiceService.isByQuantity(service)) return null;

  const discount = toNumber(service.discount);

  return (
    <span className="serviceQuantityLine">
      {ServiceService.quantityWithUnit(service.quantity, service.unit)}
      {' × '}
      <FormattedText type="currency" text={service.unitPrice} />
      {Math.abs(discount) >= 0.01 && (
        <React.Fragment>
          {` · ${discount > 0 ? _('label/discount') : _('label/surcharge')} `}
          <FormattedText type="currency" text={Math.abs(discount)} />
        </React.Fragment>
      )}
    </span>
  );
};

export default ServiceQuantityLine;
